var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "progress",
    transform: "translate(-535 -425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    transform: "translate(535 425)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hr",
    transform: "translate(533.703 428.97)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 2.814,
    cy: 2.814,
    r: 2.814,
    transform: "translate(11.625 2.428)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M30.433,23.718v-3a4.716,4.716,0,0,0-9.433,0v3a1.715,1.715,0,0,0,1.715,1.715h.429v9a1.286,1.286,0,1,0,2.573,0,1.286,1.286,0,0,0,2.573,0v-9h.429A1.715,1.715,0,0,0,30.433,23.718Z",
    transform: "translate(-11.143 -8.051)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M50.321,45.923V38h-.932v7.923h-.932V38.932h-.932v6.991h-.932V41.728h-.932v4.194h-.932V40.33H43.8v5.593h-.932V41.262h-.932v4.661H41v.932H51.253v-.932Z",
    transform: "translate(-18.69 -21.047)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M41,59h8.389v.932H41Z",
    transform: "translate(-18.69 -32.26)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M7.288,11.607a4.274,4.274,0,0,0,3.118-1.354L8.861,9.094A2.371,2.371,0,0,1,4.906,7.319,2.387,2.387,0,0,1,6.811,4.985V3.059a4.287,4.287,0,0,0,.476,8.548Z",
    transform: "translate(20.577 -0.631)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M14.906,7.319a2.354,2.354,0,0,1-.235,1.014l1.544,1.158A4.277,4.277,0,0,0,13,3.059V4.985A2.387,2.387,0,0,1,14.906,7.319Z",
    transform: "translate(15.342 -0.631)",
    fill: "#3e3e3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.f8028a5f0ce5e1a61e33e4af1a4c5228.svg";
export { ForwardRef as ReactComponent };